import React from "react";
import { DealsContext } from "@Src/routes/deals/Deals.context";
import { useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import { Feedback } from "@accessdev/feedback-client";

export default function ReportAProblem() {
  const context = React.useContext(DealsContext);
  const member = useSelector(selectors.getMember);
  const language = useSelector(selectors.getLanguageSelector);
  const { store, selectedLocation, currentOffer } = context;
  const { street_address, city_locality, state_region, postal_code } = selectedLocation;
  const locationInfo = `${store.name} ${street_address || ""} ${
    city_locality || ""
  } ${state_region || ""} ${postal_code || ""}`;
  const offerFeedbackData = {
    member_name: `${member.first_name} ${member.last_name}`,
    member_email: member.email,
    offer_key: currentOffer?.offer_key || "",
    location: locationInfo,
    location_id: selectedLocation.location_id || "",
    origin: "DEALS_UI",
  };

  return <Feedback type="Report a problem" offerData={offerFeedbackData} language={language} />;
}
